import unescapedText from 'I18n/utils/unescapedText';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { useState } from 'react';
import { ReviewPopover } from 'trellis-ecosystem';
import { EDIT_REASONS } from '../../constants/EditReasons';
import { useEcosystemReviews } from '../../hooks/useEcosystemReviews';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EcosystemReviewPopover({
  bodyContent,
  children,
  customValidationErrors,
  defaultReview,
  editedReview,
  errorAlertMessage,
  errorAlertTitle,
  headerContent,
  offeringId,
  onChange,
  onClose,
  onFail,
  onSuccess,
  overrideSubmitValidation,
  popoverProps,
  ratingSection,
  requireEditReason = true,
  reviewFormatter,
  reviewType,
  submitButtonText,
  successAlertMessage,
  successAlertTitle,
  validationSchema
}) {
  const isEditing = !!editedReview;
  const [editReason, setEditReason] = useState(requireEditReason ? '' : 'OTHER');
  const {
    finalizedDefaultReview,
    formattedCustomValidationErrors,
    formattedValidationSchema,
    handleChange,
    handleSubmit
  } = useEcosystemReviews({
    customValidationErrors,
    defaultReview,
    editedReview,
    editReason,
    errorAlertMessage,
    errorAlertTitle,
    offeringId,
    onChange,
    onFail,
    onSuccess,
    overrideSubmitValidation,
    reviewFormatter,
    reviewType,
    successAlertMessage,
    successAlertTitle,
    validationSchema
  });
  return /*#__PURE__*/_jsx(ReviewPopover, {
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [ratingSection, isEditing && requireEditReason && /*#__PURE__*/_jsx(FormControl, {
        label: unescapedText('marketplace-ui-reviews.wizard.editReason'),
        required: true,
        children: /*#__PURE__*/_jsx(Select, {
          onChange: ({
            target: {
              value
            }
          }) => {
            setEditReason(value);
          },
          options: EDIT_REASONS.map(reason => ({
            value: reason,
            text: unescapedText(`marketplace-ui-reviews.wizard.editReasons.${reason}`)
          }))
        })
      }), bodyContent]
    }),
    customValidationErrors: formattedCustomValidationErrors,
    defaultReview: finalizedDefaultReview,
    headerContent: headerContent,
    onChange: handleChange,
    onClose: onClose,
    onSubmit: handleSubmit,
    popoverProps: popoverProps,
    submitButtonText: submitButtonText,
    validationSchema: formattedValidationSchema,
    children: children
  });
}